<template>
    <div class="body">
      <div class="header">
        <el-form :model="accountForm" :inline="true">
          <el-form-item>
            <el-button class="btn-style btn-redownload" type="primary" @click="tohandleEdit">新增</el-button>
            <el-button  class="btn-style btn-delete" type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
        </el-form>
        <div style="display: flex">
          <el-upload
            class="upload-demo"
            action="#"
            accept="xlsx,xls"
            multiple
            :limit="1"
            :auto-upload="false"
            :with-credentials="false"
            :show-file-list="false"
          >
          <!-- <el-button size="small" type="primary">导入</el-button> -->
          </el-upload>
          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
      </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="schemeName"
            align="center"
            label="面板雕刻设置名称"
          ></el-table-column>
          <el-table-column
            prop="cuttingNumber"
            align="center"
            label="切断刀编号"
          ></el-table-column>
          <el-table-column
            prop="millingNumber"
            align="center"
            label="反铣刀编号"
          ></el-table-column>
        
          <el-table-column
            prop="blockNumber"
            align="center"
            label="定位块切割刀编号"
          ></el-table-column>
          <el-table-column
            prop="burinNumber"
            align="center"
            label="三维刀编号"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            label="设置时间"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success" size="small" @click="handleEdit(row)">编辑</el-link>
          </template>
        </el-table-column>
        </el-table>
      </div>


      <password ></password>
      <el-dialog title="编辑面板雕刻设置" :visible.sync="dialogVisible"  
                 text-align="center"
                :close-on-click-modal="false"
                class="order-dialog"
                width="75%"
                center>
        <el-form
        ref="accountForm"
                    :model="accountForm"
                    class="demo-accountForm form-style"
        >
        <div class="accountForm-header">
          <el-row :gutter="24">
          <el-col :span="8">
                <el-form-item label="面板雕刻设置名称" prop="outreachValue">
            <el-input v-model="accountForm.schemeName" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item   label="雕刻机类型" prop="remark">
          <el-select clearable size="small" v-model="accountForm.machineType">
            <el-option
              v-for="item in machineType"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
        </el-col>
        </el-row>
    <el-divider> <h1  class="drspen">反铣</h1></el-divider>

         
    

              <el-row :gutter="24">
              <el-col :span="8">
          <el-form-item label="反铣刀编号" prop="panelMaterial">
            <el-input v-model="accountForm.millingNumber" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8">
          <el-form-item   label="反铣刀雕刻方向" prop="remark">
          <el-select clearable size="small" v-model="accountForm.millingDirection">
            <el-option
              v-for="item in directionStatus"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
          <el-col :span="8">
          <el-form-item label="反铣刀进给量" prop="panelMaterial">
            <el-input v-model="accountForm.millingLoad" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>

              <el-row :gutter="24">
              <el-col :span="8">
          <el-form-item label="反铣刀抬刀z值" prop="panelMaterial">
            <el-input v-model="accountForm.millingKnifez" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8">
          <el-form-item label="反铣刀下刀Z值" prop="outreachValue">
            <el-input v-model="accountForm.millingCutz" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8">
          <el-form-item label="反铣刀转速" prop="panelMaterial">
            <el-input v-model="accountForm.millingSpeed" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>
              <el-row :gutter="24">
              <el-col :span="8">
          <el-form-item label="反铣刀具直径" prop="panelMaterial">
            <el-input v-model="accountForm.millingDiameter" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="翻板定位方式" prop="panelMaterial">
            <el-select clearable size="small" v-model="accountForm.copyMode">
            <el-option
              v-for="item in copyMode"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="反铣内缩值" prop="panelMaterial">
            <el-input v-model="accountForm.millingContractr" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>
              <el-divider><h1  class="drspen">定位块</h1></el-divider>


              <el-row :gutter="24">
              <el-col :span="8">
          <el-form-item label="定位块切割刀编号" prop="panelMaterial">
            <el-input v-model="accountForm.blockNumber" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8">
          <el-form-item   label="定位块切割方向" prop="remark">
          <el-select clearable size="small" v-model="accountForm.blockDirection">
            <el-option
              v-for="item in directionStatus"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
          <el-col :span="8">
          <el-form-item label="定位块切割进给量" prop="panelMaterial">
            <el-input v-model="accountForm.blockLoad" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>

              <el-row :gutter="24">
              <el-col :span="8">
          <el-form-item label="定位块切割抬刀z值" prop="panelMaterial">
            <el-input v-model="accountForm.blockKnifez" type="input-name"   ></el-input>
          </el-form-item>  
        </el-col>
          <el-col :span="8">  
          <el-form-item label="定位块切割下刀Z值" prop="outreachValue">
            <el-input v-model="accountForm.blockCutz" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8">
          <el-form-item label="定位块切割转速" prop="panelMaterial">
            <el-input v-model="accountForm.blockSpeed" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>

              <el-row :gutter="24">
              <el-col :span="8">
          <el-form-item label="定位块切割直径" prop="panelMaterial">
            <el-input v-model="accountForm.blockDiameter" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>
              <el-divider><h1  class="drspen">三维刀</h1></el-divider>

              <el-row :gutter="24">
              <el-col :span="8">
          <el-form-item label="三维刀编号" prop="panelMaterial">
            <el-input v-model="accountForm.burinNumber" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8">  
          <el-form-item   label="三维刀雕刻方向" prop="remark">
          <el-select clearable size="small" v-model="accountForm.burinDirection">
            <el-option
              v-for="item in directionStatus"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
          <el-col :span="8">  
          <el-form-item label="三维刀角度" prop="panelMaterial">
            <el-input v-model="accountForm.burinAngle" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>

              <el-row :gutter="24">
              <el-col :span="8">
          <el-form-item label="三维刀板材厚度" prop="panelMaterial">
            <el-input v-model="accountForm.burinThickness" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8"> 
          <el-form-item label="三维刀进给量" prop="panelMaterial">
            <el-input v-model="accountForm.burinLoad" type="input-name"   ></el-input>
          </el-form-item>   
        </el-col>
          <el-col :span="8">  
          <el-form-item label="三维刀抬刀z值" prop="outreachValue">
            <el-input v-model="accountForm.burinKnifez" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>

              <el-row :gutter="24">
              <el-col :span="8">
          <el-form-item label="三维刀下刀Z值" prop="panelMaterial">
            <el-input v-model="accountForm.burinCutz" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8"> 
          <el-form-item label="三维刀转速" prop="panelMaterial">
            <el-input v-model="accountForm.burinSpeed" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8"> 
          <el-form-item label="三维刀直径" prop="panelMaterial">
            <el-input v-model="accountForm.burinDiameter" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>
              <el-row :gutter="24">
              <el-col :span="8">  
          <el-form-item   label="三维刀顺序" prop="remark">
          <el-select clearable size="small" v-model="accountForm.burinOrder">
            <el-option
              v-for="item in order"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
              <el-divider><h1  class="drspen">切断刀</h1></el-divider>

              <el-row :gutter="24">  
          <el-col :span="8">
            <el-form-item label="切断刀编号" prop="outreachValue">
            <el-input v-model="accountForm.cuttingNumber" type="input-name"   ></el-input>
          </el-form-item>
      </el-col>
          <el-col :span="8">
            <el-form-item   label="切断刀雕刻方向" prop="remark">
          <el-select clearable size="small" v-model="accountForm.cuttingDirection">
            <el-option
              v-for="item in directionStatus"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
        </el-col>
        <el-col :span="8">
              <el-form-item label="切断刀进给量" prop="panelMaterial">
            <el-input v-model="accountForm.cuttingLoad" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>
       

              <el-row :gutter="24">
          <el-col :span="8">
          <el-form-item label="切断刀抬刀Z值" prop="panelMaterial">
            <el-input v-model="accountForm.cuttingKnifez" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8">
          <el-form-item label="切断刀下刀Z值" prop="panelMaterial">
            <el-input v-model="accountForm.cuttingCutz" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="切断刀转速" prop="panelMaterial">
            <el-input v-model="accountForm.cuttingSpeed" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
    
              </el-row>
              <el-row :gutter="24">
                <el-col :span="8">
          <el-form-item label="切断刀直径" prop="panelMaterial">
            <el-input v-model="accountForm.cuttingDiameter" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8">
            <el-form-item label="切断刀外扩值" prop="panelMaterial">
            <el-input v-model="accountForm.cuttingOutward" type="input-name"   ></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="8">  
          <el-form-item   label="切断刀顺序" prop="remark">
          <el-select clearable size="small" v-model="accountForm.cuttingOrder">
            <el-option
              v-for="item in order"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-col>
              </el-row>

              <el-divider><h1  class="drspen">直边切割</h1></el-divider>

              <el-row :gutter="24">  
          <el-col :span="8">
            <el-form-item label="直边切割编号" prop="outreachValue">
            <el-input v-model="accountForm.straightNumber" type="input-name"   ></el-input>
          </el-form-item>
      </el-col>
          <el-col :span="8">
            <el-form-item   label="直边切割雕刻方向" prop="remark">
          <el-select clearable size="small" v-model="accountForm.straightDirection">
            <el-option
              v-for="item in directionStatus"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
        </el-col>
        <el-col :span="8">
              <el-form-item label="直边切割进给量" prop="panelMaterial">
            <el-input v-model="accountForm.straightLoad" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>
       

              <el-row :gutter="24">
          <el-col :span="8">
          <el-form-item label="直边切割抬刀Z值" prop="panelMaterial">
            <el-input v-model="accountForm.straightKnifez" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8">
          <el-form-item label="直边切割下刀Z值" prop="panelMaterial">
            <el-input v-model="accountForm.straightCutz" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="直边切割转速" prop="panelMaterial">
            <el-input v-model="accountForm.straightSpeed" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
    
              </el-row>
              <el-row :gutter="24">
                <el-col :span="8">
          <el-form-item label="直边切割直径" prop="panelMaterial">
            <el-input v-model="accountForm.straightDiameter" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="切割螺旋率" prop="panelMaterial">
            <el-input v-model="accountForm.straightHelicity" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="板材厚度" prop="panelMaterial">
            <el-input v-model="accountForm.straightThickness" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>

              <el-row :gutter="24">
                <el-col :span="8">
          <el-form-item label="直边切割厚壁" prop="panelMaterial">
            <el-input v-model="accountForm.straightWall" type="input-name"   ></el-input>
          </el-form-item>
              </el-col>
              </el-row>

              <el-divider><h1  class="drspen">笔画拼接</h1></el-divider>

              <el-row :gutter="24">  
          <el-col :span="8">
            <el-form-item label="笔画拼接编号" prop="outreachValue">
            <el-input v-model="accountForm.strokeNumber" type="input-name"   ></el-input>
          </el-form-item>
      </el-col>
          <el-col :span="8">
            <el-form-item   label="笔画拼接雕刻方向" prop="remark">
          <el-select clearable size="small" v-model="accountForm.strokeDirection">
            <el-option
              v-for="item in directionStatus"
              clearable
              :key="item.value"
            :label="item.label"
            :value="item.value"
            />
          </el-select>
        </el-form-item>
        </el-col>
        <el-col :span="8">
              <el-form-item label="笔画拼接进给量" prop="panelMaterial">
            <el-input v-model="accountForm.strokeLoad" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>
       

              <el-row :gutter="24">
          <el-col :span="8">
          <el-form-item label="笔画拼接抬刀Z值" prop="panelMaterial">
            <el-input v-model="accountForm.strokeKnifez" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8">
          <el-form-item label="笔画拼接下刀Z值" prop="panelMaterial">
            <el-input v-model="accountForm.strokeCutz" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="笔画拼接转速" prop="panelMaterial">
            <el-input v-model="accountForm.strokeSpeed" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
    
              </el-row>
              <el-row :gutter="24">
                <el-col :span="8">
          <el-form-item label="笔画拼接直径" prop="panelMaterial">
            <el-input v-model="accountForm.strokeDiameter" type="input-name"   ></el-input>
          </el-form-item>
        </el-col>
              </el-row>

        </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="editAccount()">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
   import password from '@/components/password.vue';
  import {selectPanel,upDatePanel,bathDeleteCarving} from '@/api/set/panelCarving'
  export default {
    components: {
      password
  },
    data() {
      return {
      direction: 'rtl',
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        drawer: false,
        access: '',
        date: '',
        dialogVisible: false,
        conTract: [],
        copyMode:["切边定位(东阳)","两孔定位(圣昊)","对称孔定位(梵匠)","钻孔定位(华卓)","固定孔定位(风驰)","四孔定位(洛可斯)","随机样块（洛可斯）","靠尺定位"],
        machineType:[{
        value: '0',
        label: '横版'
      }, {
        value: '1',
        label: '竖版'
      }, {
        value: '2',
        label: '横版和竖版'
      },{
        value: '3',
        label: '竖版逆向'
      }],
      directionStatus:[{
        value: '0',
        label: '顺时针'
      }, {
        value: '1',
        label: '逆时针'
      }],
      order:[{
        value: 0,
        label: '顺序'
      }, {
        value: 1,
        label: '逆序'
      }],
        accountForm: {
          direction:'',
          cuttingDirection:'',
          cuttingNumber: '',
          cuttingLoad: '',
          cuttingKnifez:'',
          cuttingCutz:'',
          cuttingSpeed:'',
          cuttingDiameter:'',
          cuttingOutward:'',
          cuttingOrder:'',

          millingNumber: '',
          millingDirection:'',
          millingLoad: '',
          millingKnifez:'',
          millingCutz:'',
          millingSpeed:'',
          millingDiameter:'',
          machineType:'',
          millingContractr:'',

          blockNumber: '',
          blockDirection:'',
          blockLoad: '',
          blockKnifez:'',
          blockCutz:'',
          blockSpeed:'',
          blockDiameter:'',

          burinNumber: '',
          burinDirection:'',
          burinAngle: '',
          burinLoad:'',
          burinKnifez:'',
          burinCutz:'',
          burinSpeed:'',
          burinDiameter:'',
          burinThickness:'',
          burinOrder:'',
          
          straightNumber:'',
          straightDirection:'',
          straightLoad:'',
          straightKnifez:'',
          straightCutz:'',
          straightSpeed:'',
          straightDiameter:'',
          straightWall:'',
          straightHelicity:'',
          straightThickness:'',

          strokeNumber:'',
          strokeDirection:'',
          strokeLoad:'',
          strokeKnifez:'',
          strokeCutz:'',
          strokeSpeed:'',
          strokeDiameter:'',
          schemeName:'',
          id:'',
          access:''
        },
        ImpositionFileDTO:{
            startTime: '',
            endTime: '',
            status: '2'
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
        }
      }
    },
    
  
    mounted() {
      this.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.dialogVisible = true
      },
      getTableData() {
        selectPanel(this.access).then((res) => {
            console.log(res);
          this.conTract = res.data.data
          console.log(this.conTract )
        //  this.total = Number(res.data.data.total)
        })
      },
      handleEdit(row) {
        this.dialogVisible = true
        if(row){
          this.accountForm=row;
        }
       
      },
      submitForm(accountForm) {
        this.$refs[accountForm].validate((valid) => {
          if (valid) {
            addCarving(this.accountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',
                
              }),
              this.getTableData()
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      handleDelete() {
        if(this.multipleSelection.length==0){
              this.$message({
                type: "error",
                message: "sorry,你还没有勾选任何文件呢!"
              });
              return;
            } 
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            bathDeleteCarving(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
     
  
    
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
      //修改
      editAccount() {
        upDatePanel(this.accountForm).then((res) => {
          if (res.data.msg === '操作成功') {
            this.$message({
              type: 'success',
              message: '保存成功!'
            })
            this.dialogVisible = false
          } else if (res.data.msg !== '操作成功') {
            this.$message({
                type: 'info',
                message: res.data.data
              })
          }
          this.getTableData()
        }
        )
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.ImpositionFileDTO.startTime = e[0]
          this.ImpositionFileDTO.endTime = e[1]
        } else if (!e) {
          this.ImpositionFileDTO.startTime = ''
          this.ImpositionFileDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },
  
    
    }
  }
  </script>
  
  <style lang="scss" scoped>
  
  .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin: 20px;
  }
  
  .body {
      overflow: auto;
  }
  
  .pagination {
      margin-top: 10px;
      margin-right: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      position: relative;
  }
  
  .el-pagination ::v-deep.el-pagination__total {
      line-height: 36px;
  }
  
  .el-table .warning-row {
      background: oldlace;
  }
  
  .el-table .success-row {
      background: #f0f9eb;
  }
  .goodsTableData{
      margin: 20px 0 ;
  }
  .btn-style{
      min-width: 72px;
      border-radius: 8px;
  }
  .btn-search{
      background: var(--theme-color);
  }
  .btn-buy{
      background: #FF8429;
  }
  .btn-print{
      background: #4093FF;
  }
  .btn-delete{
      background: #FF4D4D;
  }
  .btn-view{
      background: var(--theme-color);
  }
  .product-form .el-form-item{
      margin-bottom: 0;
  }
  .table-content{
      margin: 20px;
  }
  .check-all{
      color: #333;
      font-size: 16px;
      margin-right: 20px;
      cursor: pointer;
  }
  .el-pagination{
      margin: 0;
  }
  
  .el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
      border-radius: 8px;
  }
  
  .drspen{
    font-family: "Algerian";
            color: rgb(139, 0, 12);
  }
  .table-value{
      color: var(--color);
  }
  .table-info{
      width: 80%;
      justify-content: space-between;
  }
  .table-info > p{
      display: inline-block;
      width: 150px;
      padding-right: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex-shrink: 0;
  }
  
  .table-item{
      background: #F7F7F7;
      margin: 8px 0;
      border-radius: 12px;
      padding: 12px;
  }
  .table-image{
      width: 100px;
      height: 50px;
      margin-right: 20px;
  }
  ::v-deep.table-image .image-slot{
      height: 50px;
      display: flex;
      align-items: center;
  }
  ::v-deep.table-image .image-slot i{
      font-size: 50px;
  }
  .pay{
      color:var(--theme-color);
  }
  .no-pay{
      color:#FF4D4D;
  }
  .btn-group{
      display: flex;
      flex-direction: column;
      gap: 10px;
  }
  .btn-group .el-button{
      border-radius: 20px;
      width: 76px;
  }
  .btn-collection{
      background: #F9DDDD;
  }
  .btn-view-detail{
      background: #D3F2E4;
      color: var(--theme-color);
  }
  .el-divider--vertical {
  display: inline-block;
  weight: 1px;
  height: 70%;
  margin: 0 8px;
  background: 0 0;
  border-left: 2px dashed #e8eaec;
  position: relative;
}

  .btn-reckon{
      background: rgb(245, 233, 212);
    
  }
  
  ::v-deep.order-dialog .el-dialog{
      border-radius: 24px;
  }
  .operator label{
      letter-spacing: 5px;
  }
  ::v-deep.dialog-upload{
      display: flex;
  }
  ::v-deep.dialog-upload .el-form-item__label{
      flex-shrink: 0;
  }
  ::v-deep.dialog-upload .el-form-item__content{
      justify-content: right;
  }
  ::v-deep.dialog-upload .avatar-uploader{
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      border: 1px solid #D8E0DD;
  }
  ::v-deep.dialog-upload .el-upload--text{
      width: 100%;
      height: 100%;
  }
  ::v-deep.dialog-upload img{
      max-width: 100px;
  }
  .accountForm-header{
      background: #F7F7F7;
      border-radius: 16px;
      margin-bottom: 20px;
      padding: 20px;
  }
  .btn-add{
      background: #FF8429;
      border-radius: 8px;
  }
  .form-submit{
      background: var(--theme-color);
      border-radius: 8px;
  }
  ::v-deep.el-table thead th{
      background: #EAF4F0;
      color: var(--secondColor);
  }
  .table-no-pay{
      background: #ffeded;
  }
  
  ::v-deep.el-icon-remove-outline{
      font-size: 32px;
      color: #a3d8f9cc;
  }

  
  </style>
  